import React, { FC } from 'react';
import { Input } from '@duxton-web/ui';
import { debounce } from 'lodash';

import { AppVersion, CountrySelector } from '@/common/components';
import BackendSelect from '@/common/selects/BackendSelect';
import FuseSelectComponent from '@/common/selects/FuseSelect/FuseSelect';
import LanguageInput from '@/common/selects/LanguageInput';
import Service from '@/lib/App';
import { sortTreeData } from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/ConstraintBlocks/ConstraintBlock/ConstraintValueInput/ConstraintValueInput';
import SelectTreeV2 from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/ConstraintBlocks/ConstraintBlock/ConstraintValueInput/SelectTree/SelectTreeV2';
import { DropDownList } from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/ConstraintBlocks/ConstraintBlock/FacetConfigurationMap/FacetConfigurationMap';

interface InputProps {
  value: string;
  onChange: (e: any) => void;
}

export interface FacetInputProps extends InputProps {
  type?: string;
}

function FacetControl(props) {
  const { type, value: constraintValue, onChange, ...others } = props;

  function facetValueChange(val) {
    onChange(val);
  }

  switch (type) {
    case 'svc':
      return (
        <FuseSelectComponent
          value={constraintValue}
          onChange={facetValueChange}
          {...others}
        />
      );
    case 'city': {
      const treeData = Service.cache!.getCityCountryTreeData(false);
      const sortedTreeData = sortTreeData(treeData);

      return (
        <SelectTreeV2
          value={constraintValue}
          onChange={facetValueChange}
          {...{
            ...others,
            treeData: sortedTreeData,
            treeNodeFilterProp: 'title',
            tokenizable: true,
          }}
        />
      );
    }
    case 'dvc':
      return <AppVersion value={constraintValue} onChange={facetValueChange} />;
    case 'pre':
      return (
        <BackendSelect
          value={constraintValue}
          {...others}
          onChange={facetValueChange}
        />
      );
    case 'ctry':
      return (
        <CountrySelector value={constraintValue} onChange={facetValueChange} />
      );
    case 'dla':
      return (
        <LanguageInput
          value={constraintValue}
          {...others}
          onChange={facetValueChange}
        />
      );
    case 'ost':
      return (
        <DropDownList
          value={constraintValue}
          {...others}
          onChange={facetValueChange}
          availableValues={{ ios: 'iOS', android: 'Android' }}
        />
      );
    default:
      return (
        <Input
          style={{
            width: 300,
          }}
          onChange={debounce((e) => onChange(e.target.value), 200)}
        />
      );
  }
}

const TestingFacetComponent: FC<FacetInputProps> = (props) => {
  return <FacetControl {...props} />;
};

export default TestingFacetComponent;
